(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shredrite-5ways"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var enableReveal = root.getAttribute('data-sr-reveal') === 'true';
    if (!reduce && enableReveal && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          if (e.isIntersecting) { e.target.style.opacity = '1'; e.target.style.transform = 'none'; io.unobserve(e.target); }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      root.querySelectorAll('[data-reveal]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.82) {
          el.style.opacity = '0';
          el.style.transform = 'translateY(20px)';
          el.style.transition = 'opacity .7s cubic-bezier(.2,.7,.2,1), transform .7s cubic-bezier(.2,.7,.2,1)';
          io.observe(el);
        }
      });
    }

    root.querySelectorAll('[data-faq]').forEach(function (item) {
      var btn = item.querySelector('[data-faq-toggle]');
      var panel = item.querySelector('[data-faq-panel]');
      var icon = item.querySelector('[data-faq-icon]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        item.setAttribute('data-open', String(!open));
        panel.style.gridTemplateRows = open ? '0fr' : '1fr';
        btn.setAttribute('aria-expanded', String(!open));
        if (icon) icon.textContent = open ? '+' : '−';
      });
    });

    var copyBtn = root.querySelector('[data-sr="copy-link"]');
    if (copyBtn) {
      var label = copyBtn.querySelector('[data-sr="copy-label"]');
      copyBtn.addEventListener('click', function () {
        var done = function () {
          if (!label) return;
          var prev = label.getAttribute('data-default') || label.textContent;
          label.textContent = 'Link copied';
          copyBtn.style.borderColor = '#016D44';
          copyBtn.style.color = '#016D44';
          setTimeout(function () { label.textContent = prev; copyBtn.style.borderColor = ''; copyBtn.style.color = ''; }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).then(done).catch(done);
        } else { done(); }
      });
    }

    var share = root.querySelector('[data-sr="wa-share"]');
    if (share) {
      share.setAttribute('href', 'https://wa.me/?text=' + encodeURIComponent('Quran Disposal in Singapore: 5 Options Compared ' + window.location.href));
    }

    var bar = root.querySelector('[data-sr="sticky-bar"]');
    var start = root.querySelector('[data-sr="sticky-start"]');
    var cta = root.querySelector('[data-sr="closing-cta"]');
    if (bar) {
      var pastHeader = false, ctaVisible = false;
      var update = function () {
        var isMobile = window.innerWidth < 768;
        var show = isMobile && pastHeader && !ctaVisible;
        bar.style.transform = show ? 'translateY(0)' : 'translateY(160%)';
        bar.style.opacity = show ? '1' : '0';
        bar.style.pointerEvents = show ? 'auto' : 'none';
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      };
      if ('IntersectionObserver' in window) {
        if (start) new IntersectionObserver(function (en) { pastHeader = en[0].boundingClientRect.top < 0; update(); }, { threshold: 0 }).observe(start);
        if (cta) new IntersectionObserver(function (en) { ctaVisible = en[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(cta);
      }
      window.addEventListener('resize', update, { passive: true });
      update();
    }
  }

  function boot() { document.querySelectorAll('[data-sr-root]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();

  } catch(e) { console.error(e); }
})();
})();
